import React from 'react';
import './NoReportData.scss';

interface NoReportDataProps {
  sectionType: string;
}

export const NoReportData: React.FC<NoReportDataProps> = ({ sectionType }) => {
  return (
    <div className="no-report-data">
      <div>
        <p className="no-report-data__title">No {sectionType}s added</p>
        <p className="no-report-data__content">
          Select{' '}
          <b>
            <u>Add {sectionType}</u>
          </b>{' '}
          to choose which groups you want to sort
        </p>
        <p className="no-report-data__content">
          data by, then drag to re-order
        </p>
      </div>
    </div>
  );
};
